import { get } from 'lodash'
import ContentBuilder from '~/themes/base/components/utils/ContentBuilder/ContentBuilder.vue'
import MarketingEmbedMixin from '~/themes/cvb/mixins/MarketingEmbedMixin'

export default {
  extends: ContentBuilder,
  mixins: [MarketingEmbedMixin],
  methods: {
    getHtmlContent(block) {
      const value = get(block, 'value')
      let html

      if (!value) {
        return false
      } else {
        if (typeof value === 'string') {
          html = value
        } else {
          html = get(value, `[${this.$i18n.locale}]`, false)
        }
      }

      return this.getConsentAwareEmbedHtml(html)
    },
  },
}
